import { render, staticRenderFns } from "./Bild.vue?vue&type=template&id=54d710fe&"
import script from "./Bild.vue?vue&type=script&lang=js&"
export * from "./Bild.vue?vue&type=script&lang=js&"
import style0 from "./Bild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports